import React, { useRef, useState } from "react";
import ReactPlayer from "react-player";
import { useTranslation } from 'react-i18next';

const AudioPlayer = () => {
    const { t } = useTranslation();
    const initialTracks = [
        { id: 1, title: "Birds Sound", url: "https://cdn.pixabay.com/audio/2024/09/13/audio_7ae0f8b6e4.mp3", volume: 0.5, playing: false, loop: true },
        { id: 2, title: "Quack Continous", url: "https://commondatastorage.googleapis.com/codeskulptor-assets/sounddogs/missile.mp3", volume: 0.5, playing: false, loop: true },
        { id: 3, title: "Awakening Soul", url: "https://storage.googleapis.com/relax_prod/assets/ETH-0009_-_Awakening_Soul__-20_dB_LUFS.ogg", volume: 0.5, playing: false, loop: true },
    ];

    const [tracks, setTracks] = useState(initialTracks);
    const [newTrackUrl, setNewTrackUrl] = useState("");
    const [_isPlaying, setPlaying] = useState(false);

    // refs for each ReactPlayer
    const playerRefs = useRef({});

    const resetSettings = () => {
        setTracks(initialTracks);
        setPlaying(false);
        setNewTrackUrl("");
        // Reset to start for all players
        Object.values(playerRefs.current).forEach((player) => {
            if (player) player.seekTo(0);
        });
    };

    const globalPlayPause = () => {
        setTracks((prevTracks) =>
            prevTracks.map((track) => ({
                ...track,
                playing: !_isPlaying,
            }))
        );
        setPlaying(!_isPlaying);
    };

    const togglePlayPause = (id) => {
        setTracks((prevTracks) =>
            prevTracks.map((track) =>
                track.id === id ? { ...track, playing: !track.playing } : track
            )
        );
    };

    const changeVolume = (id, volume) => {
        setTracks((prevTracks) =>
            prevTracks.map((track) =>
                track.id === id ? { ...track, volume } : track
            )
        );
    };

    const toggleLoop = (id) => {
        setTracks((prevTracks) =>
            prevTracks.map((track) =>
                track.id === id ? { ...track, loop: !track.loop } : track
            )
        );
    };

    const removeTrack = (id) => {
        setTracks((prevTracks) => prevTracks.filter((track) => track.id !== id));
    };

    const addTrack = () => {
        if (newTrackUrl.trim()) {
            const newId = tracks.length > 0 ? tracks[tracks.length - 1].id + 1 : 1;
            setTracks([
                ...tracks,
                { id: newId, url: newTrackUrl, volume: 0.5, playing: false, loop: false },
            ]);
            setNewTrackUrl("");
        }
    };

    return (
        <div style={{ padding: "20px" }}>
            <h2>Enhanced Multi-Sound Audio Player</h2>

            <div style={{ marginBottom: "20px" }}>
                <input
                    type="text"
                    placeholder={t("videoPlayer.enterTrackUrl")}
                    value={newTrackUrl}
                    onChange={(e) => setNewTrackUrl(e.target.value)}
                    style={{ width: "300px", marginRight: "10px" }}
                />
                <button onClick={addTrack}>Add Track</button>
                <button onClick={globalPlayPause}>
                    {_isPlaying ? "Pause" : "Play"}
                </button>
                <button
                    onClick={resetSettings}
                    style={{ marginLeft: "10px", background: "#f7ba31", color: "#fff" }}
                >
                    Reset Settings
                </button>
            </div>

            {tracks.map((track) => (
                <div key={track.id} style={{ marginBottom: "20px", border: "1px solid #ccc", padding: "10px" }}>
                    <h4>{track.title}</h4>
                    <div>
                        <button onClick={() => togglePlayPause(track.id)}>
                            {track.playing ? "Pause" : "Play"}
                        </button>
                        <button onClick={() => toggleLoop(track.id)}>
                            {track.loop ? t("videoPlayer.disableLoop") : t("videoPlayer.enableLoop")}
                        </button>
                        <button onClick={() => removeTrack(track.id)} style={{ marginLeft: "10px", color: "red" }}>
                            Remove
                        </button>
                    </div>
                    <div style={{ marginTop: "10px" }}>
                        <input
                            type="range"
                            min="0"
                            max="1"
                            step="0.01"
                            value={track.volume}
                            onChange={(e) => changeVolume(track.id, parseFloat(e.target.value))}
                        />
                        <span style={{ marginLeft: "10px" }}>
                            Volume: {Math.round(track.volume * 100)}%
                        </span>
                    </div>
                    <ReactPlayer
                        ref={(player) => (playerRefs.current[track.id] = player)}
                        url={track.url}
                        playing={track.playing}
                        volume={track.volume}
                        loop={track.loop}
                        controls={true}
                        height="60px"
                        width="100%"
                    />
                </div>
            ))}
        </div>
    );
};

export default AudioPlayer;

